export const financialConstants = {
	GET_FINANCIALS_SUCCESS: "GET_FINANCIALS_SUCCESS",
	GET_FINANCIALS_ERROR: "GET_FINANCIALS_ERROR",
	GET_FINANCIALS_REQUEST: "GET_FINANCIALS_REQUEST",

	ADD_FINANCIAL_SUCCESS: "ADD_FINANCIAL_SUCCESS",
	ADD_FINANCIAL_ERROR: "ADD_FINANCIAL_ERROR",
	ADD_FINANCIAL_REQUEST: "ADD_FINANCIAL_REQUEST",

	EDIT_FINANCIAL_SUCCESS: "EDIT_FINANCIAL_SUCCESS",
	EDIT_FINANCIAL_ERROR: "EDIT_FINANCIAL_ERROR",
	EDIT_FINANCIAL_REQUEST: "EDIT_FINANCIAL_REQUEST",

	DELETE_FINANCIAL_SUCCESS: "DELETE_FINANCIAL_SUCCESS",
	DELETE_FINANCIAL_ERROR: "DELETE_FINANCIAL_ERROR",
	DELETE_FINANCIAL_REQUEST: "DELETE_FINANCIAL_REQUEST",

	GET_BANK_BALANCES_SUCCESS: "GET_BANK_BALANCES_SUCCESS",
	GET_BANK_BALANCES_ERROR: "GET_BANK_BALANCES_ERROR",
	GET_BANK_BALANCES_REQUEST: "GET_BANK_BALANCES_REQUEST",

	ADD_BANK_BALANCE_SUCCESS: "ADD_BANK_BALANCE_SUCCESS",
	ADD_BANK_BALANCE_ERROR: "ADD_BANK_BALANCE_ERROR",
	ADD_BANK_BALANCE_REQUEST: "ADD_BANK_BALANCE_REQUEST",

	EDIT_BANK_BALANCE_SUCCESS: "EDIT_BANK_BALANCE_SUCCESS",
	EDIT_BANK_BALANCE_ERROR: "EDIT_BANK_BALANCE_ERROR",
	EDIT_BANK_BALANCE_REQUEST: "EDIT_BANK_BALANCE_REQUEST",

	DELETE_BANK_BALANCE_SUCCESS: "DELETE_BANK_BALANCE_SUCCESS",
	DELETE_BANK_BALANCE_ERROR: "DELETE_BANK_BALANCE_ERROR",
	DELETE_BANK_BALANCE_REQUEST: "DELETE_BANK_BALANCE_REQUEST",
};
